import { Termin } from '@/domain/termine/shared/types/Termin';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@/components/ui/button';
import { TerminInfo } from '@/domain/termine/features/Calendar/shared/TerminInfo/TerminInfo';
import { useDayPopover } from '@/domain/termine/features/Calendar/Grid/DayCell/Popover/DayPopoverContext';
import { Link, useParams } from 'react-router-dom';
export function TerminPopoverContent({
  termin,
  onDeleteClick,
}: {
  termin: Termin;
  onDeleteClick: () => void;
}) {
  const fromDayPopover = useDayPopover();
  const { year, month } = useParams();

  return (
    <div
      className={`w-[340px] bg-white shadow-lg p-5 rounded-lg ${
        fromDayPopover ? 'translate-x-[15px]' : ''
      }`}>
      <TerminInfo termin={termin} />
      <div className="flex justify-end items-center gap-3 mt-5">
        <Button size="sm" variant="ghost" onClick={onDeleteClick}>
          <FontAwesomeIcon className="text-primary-red-400" icon={faTrashCan} />
        </Button>
        <Button asChild size="sm" variant="ghost">
          <Link
            to={`/termine/uebersicht/${year}/${month}/edit/${termin.id}`}
            state={{ datum: termin.datum }}>
            <FontAwesomeIcon className="text-primary-blue-600" icon={faEdit} />
          </Link>
        </Button>
      </div>
    </div>
  );
}
